export default __webpack_public_path__ + "static/media/burger_menu.5a79a51a.png";